import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Thumb = (props) => (
    <svg
        fill='none'
        height='31'
        viewBox='0 0 30 31'
        width='30'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M11.3563 0.729741C11.5598 0.285123 12.0039 0 12.4929 0H13.2248C16.3567 0 18.792 2.72462 18.4419 5.83692L17.7485 12H25.0461C27.5059 12 29.5 13.9941 29.5 16.4539C29.5 17.682 28.9929 18.8556 28.0986 19.6973L28 19.7901V22.3611C28 23.2086 27.7251 24.0331 27.2167 24.7111L27 25V27.0833C27 29.2465 25.2464 31 23.0833 31H11.4444C10.8855 31 10.3416 30.8187 9.89444 30.4833L6.60556 28.0167C6.59113 28.0058 6.57359 28 6.55556 28H2.58333C1.1566 28 0 26.8434 0 25.4167V17.9467C0 17.101 0.41389 16.3089 1.10808 15.826L6.00564 12.419L11.3563 0.729741ZM13.295 2.50087L8.13659 13.7703C8.04348 13.9737 7.89748 14.1484 7.71383 14.2761L2.53575 17.8783C2.51335 17.8939 2.5 17.9194 2.5 17.9467V25.4167C2.5 25.4627 2.53731 25.5 2.58333 25.5H6.55556C7.11451 25.5 7.65839 25.6813 8.10556 26.0167L11.3944 28.4833C11.4089 28.4942 11.4264 28.5 11.4444 28.5H23.0833C23.8657 28.5 24.5 27.8657 24.5 27.0833V24.1667L25.2167 23.2111C25.4006 22.9659 25.5 22.6676 25.5 22.3611V18.7099L26.3852 17.8768C26.7775 17.5075 27 16.9927 27 16.4539C27 15.3748 26.1252 14.5 25.0461 14.5H14.9515L15.9575 5.55744C16.1383 3.95052 14.9015 2.54091 13.295 2.50087Z'
            fill='currentColor'/>
    </svg>
);

export default Thumb;
